import moment from "moment";
export const applicationDate = moment().format("YYYY-MM-DD");
